import type { CommandFactory, SlashCommand } from './types'

const createHelpMessage = (commands: SlashCommand[]): string => {
  return `
**Available Commands:**
${commands
  .map(
    (cmd) => `
- \`/${cmd.name}\`: ${cmd.description} ${cmd.aliases ? `(aliases: ${cmd.aliases.join(', ')})` : ''}`
  )
  .join('')}
`
}

export const helpCommand: CommandFactory = (context) => ({
  id: 'help',
  name: 'help',
  description: 'Show available commands',
  acceptsArgs: false,
  handler: async () => {
    // Note: The actual commands list will be injected by the hook
    // This is a placeholder that will be replaced with the actual implementation
    context.onDisplayMessage?.({
      role: 'command',
      content: 'Help command executed. Commands list will be provided by the hook.',
      timestamp: new Date(),
    })
  },
})

export { createHelpMessage }
